var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAttributes = function SvgAttributes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M752 309.76v51.52h-75.84v-51.52h-32v51.52H272v-51.52h-32v404.48h32v-51.52h372.16v51.52h32v-51.52H752v51.52h32V309.76zm-107.84 320H272V528h372.16zm0-134.72H272V393.28h372.16zM752 629.76h-75.84V528H752zm0-134.72h-75.84V393.28H752z"
  })));
};
export default SvgAttributes;